import { render, staticRenderFns } from "./InformationsAdresse.vue?vue&type=template&id=b5555664&scoped=true&"
import script from "./InformationsAdresse.vue?vue&type=script&lang=js&"
export * from "./InformationsAdresse.vue?vue&type=script&lang=js&"
import style0 from "./InformationsAdresse.vue?vue&type=style&index=0&id=b5555664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5555664",
  null
  
)

export default component.exports